import {
  CUSTOMER_VENDOR,
  FETCH_TRANSACTION,
  FETCH_TRANSACTION_SETTINGS_CODE,
  INSERT_TRANSACTION,
  INSERT_MASTER_TRANSACTION,
  INSERT_VM_MASTER_TRANSACTION,
  TRANSACTION_DETAILS,
  EDIT_TRANSACTION,
  EDIT_MASTER_TRANSACTION,
  SELECT_TRANSACTION,
  ANALYSIS_REPORT,
  POPUP_QUERY,
  DELETE_TRANSACTION,
  EDIT_PRODUCTMASTER,
  INSERT_PRODUCTMASTER,
  FINALISE_PRODUCTMASTER,
  APPROVE_TRANSACTION,
  TRANSACTION_NUMBER,
  CREATE_MATERIAL_REQUEST,
  PRODUCTS,
  VENDOR,
  PACKING_LIST,
  INSERT_JOBCARD,
  JOBCARD,
  CREATE_JOBCARD,
  UPDATE_TRANSACTION_SETTINGS,
  FETCH_SUBCATEGORY,
  VENDOR_CATEGORIES,
  VENDOR_CATEGORY_LIST,
  VENDOR_SUBCATEGORY_LIST,
  CREATE_SUBCATEGORY,
  UPDATE_SUBCATEGORY,
  DELETE_SUBCATEGORY,
  INSERT_WBOM,
  BOM_BY_PRODUCT,
  QUOTATION_REVISE,
  QUOTATION_VERSIONS,
  LAST_HEAD_DATA,
  EMPLOYEES,
} from "../config";
import { get, post } from "./apiHelper";

export const fetchTransactionByCode = ({
  transactionCode,
  page = 1,
  pageSize = 20,
  fromDate,
  toDate,
}) => {
  const normalizeDateParam = (date) => {
    if (!date) return "";
    const dateOnly = String(date).split("T")[0];
    return `${dateOnly}T00:00:00Z`;
  };

  const normalizedFromDate = normalizeDateParam(fromDate);
  const normalizedToDate = normalizeDateParam(toDate);
  const dateQuery =
    normalizedFromDate && normalizedToDate
      ? `&from_date=${normalizedFromDate}&to_date=${normalizedToDate}`
      : "";

  return get(
    `${FETCH_TRANSACTION}${transactionCode}?page=${page}&count=${pageSize}${dateQuery}`,
  );
};

export const fetchTransactionSettingsByCode = (transactionCode) =>
  get(`${FETCH_TRANSACTION_SETTINGS_CODE}${transactionCode}`);

export const fetchFilteredTransactionByCode = ({
  transactionCode,
  filterData,
  page = 1,
  pageSize = 20,
  fromDate,
  toDate,
  dateFields,
  includeOptions = false,
  sortBy,
  sortDir,
}) =>
  post(`${FETCH_TRANSACTION}filtered_data`, {
    tran_code: transactionCode,
    page,
    count: pageSize,
    filter_data: filterData?.filter_data || [],
    ...(fromDate ? { from_date: fromDate } : {}),
    ...(toDate ? { to_date: toDate } : {}),
    ...(Array.isArray(dateFields) && dateFields.length
      ? { date_fields: dateFields }
      : {}),
    ...(includeOptions ? { include_options: true } : {}),
    ...(sortBy ? { sort_by: sortBy, sort_dir: sortDir || "asc" } : {}),
  });

export const fetchTransactionByCodeAndId = (code, id) =>
  get(
    `api/v1/organisation/transaction/details?tran_code=${code}&tran_id=${id}`,
  );

export const fetchTransactionById = (transactionCode, transId) =>
  get(`${TRANSACTION_DETAILS}?tran_code=${transactionCode}&tran_id=${transId}`);

export const fetchJobCardByCodeAndId = (code, id) =>
  get(
    `api/v1/organisation/transaction/job_card/details?tran_code=${code}&tran_id=${id}`,
  );

export const insertJobCard = (submissionData) =>
  post(INSERT_JOBCARD, submissionData);

export const editJobCard = (submissionData) =>
  post(`${JOBCARD}edit`, submissionData);

export const updateJobCardStatus = (status, jobCardId) =>
  post(`${JOBCARD}${status}/${jobCardId}`, { tran_id: jobCardId });

export const updateJobCardProcessStatus = (status, jobCardData) =>
  post(`${JOBCARD}process/${status}`, jobCardData);

export const createJobcard = (requestBody) => post(CREATE_JOBCARD, requestBody);

export const insertTransactionByCode = (submissionData, transactionCode) =>
  post(`${INSERT_TRANSACTION}${transactionCode}`, submissionData);

export const editTransactionByCode = (submissionData, transactionCode) =>
  post(`${EDIT_TRANSACTION}${transactionCode}`, submissionData);

export const deleteTransactionByCode = (transactionCode, transactionId) =>
  post(`${DELETE_TRANSACTION}${transactionCode}`, { tran_id: transactionId });

export const insertMasterTransaction = (submissionData, transactionCode) => {
  if (transactionCode === "VM") {
    return post(INSERT_VM_MASTER_TRANSACTION, submissionData);
  }
  if (transactionCode === "CM") {
    return post(`${INSERT_MASTER_TRANSACTION}/CM`, submissionData);
  }
  return post(`${INSERT_TRANSACTION}${transactionCode}`, submissionData);
};

export const editMasterTransaction = (transactionCode, submissionData) =>
  post(`${EDIT_MASTER_TRANSACTION}${transactionCode}`, submissionData);

export const fetchCustomerOrVendor = ({ type }) =>
  get(`${CUSTOMER_VENDOR}${type}`);

export const fetchCustomerOrVendorwithProduct = (selectedProduct) =>
  get(`${VENDOR}?category=${selectedProduct}`);

export const fetchVendorsBySubcategory = (selectedSubcategory) =>
  get(`${VENDOR}?sub_category=${encodeURIComponent(selectedSubcategory)}`);

export const fetchSubcategoriesByCategory = (selectedCategory) =>
  get(`${FETCH_SUBCATEGORY}?category=${encodeURIComponent(selectedCategory)}`);

export const fetchVendorCategoriesList = () => get(VENDOR_CATEGORY_LIST);

export const fetchSubcategoriesByCategoryId = (categoryId) =>
  get(`${VENDOR_CATEGORY_LIST}/${categoryId}/subcategory`);

export const fetchAllVendorSubcategories = () =>
  get(`${VENDOR_SUBCATEGORY_LIST}?page=1&count=1000`);

export const fetchPickUpTransactionByCode = (type) =>
  get(`${SELECT_TRANSACTION}${type}`);

export const fetchAnalysisReportData = ({ tab, from_date, to_date }) =>
  get(
    `${ANALYSIS_REPORT}${tab}?from_date=${from_date}T00:00:00Z&to_date=${to_date}T00:00:00Z`,
  );

export const fetchAnalysisReportPage = ({
  tab,
  from_date,
  to_date,
  page = 1,
  count = 20,
  filters = [],
  includeOptions = false,
  sortBy,
  sortDir,
  rowColors = [],
}) =>
  post(`${ANALYSIS_REPORT}${tab}`, {
    from_date: `${from_date}T00:00:00Z`,
    to_date: `${to_date}T00:00:00Z`,
    page,
    count,
    filters,
    include_options: includeOptions,
    ...(sortBy ? { sort_by: sortBy, sort_dir: sortDir || "asc" } : {}),
    ...(Array.isArray(rowColors) && rowColors.length
      ? { row_colors: rowColors }
      : {}),
  });

export const fetchTransactionPopupData = (dbQuery) =>
  get(`${POPUP_QUERY}?query=${encodeURIComponent(dbQuery)}`);

export const fetchEmployeesList = (designation) =>
  get(
    `${EMPLOYEES}${
      designation ? `?designation=${encodeURIComponent(designation)}` : ""
    }`,
  );

export const fetchApprovalTransactionDetails = ({
  transactionCode,
  fromDate,
  toDate,
  page = 1,
  pageSize = 20,
  status = "",
}) => {
  const statusParam = status ? `&status=${status}` : "";
  return get(
    `api/v1/organisation/transaction/approve/details/${transactionCode}?from_date=${fromDate}&to_date=${toDate}&page=${page}&count=${pageSize}${statusParam}`,
  );
};

export const approveTransaction = (submissionData, transactionCode) =>
  post(`${APPROVE_TRANSACTION}${transactionCode}`, submissionData);

export const insertProductMaster = (submissionData) =>
  post(INSERT_PRODUCTMASTER, submissionData);

export const finaliseProductMaster = (submissionData) =>
  post(FINALISE_PRODUCTMASTER, submissionData);

export const editProductMaster = (submissionData) =>
  post(EDIT_PRODUCTMASTER, submissionData);

export const fetchTransactionNo = (transactionCode) =>
  get(`${TRANSACTION_NUMBER}${transactionCode}`, { noCache: true });

const getMasterEndpoint = (masterType) => {
  const endpoints = {
    CM: "customer_master",
    VM: "vendor_master",
    PM: "product_master",
  };
  return endpoints[masterType] || "";
};

export const fetchMasterTableData = (masterType, subType) => {
  const endpoint = getMasterEndpoint(masterType);
  return get(`api/v1/organisation/${endpoint}/${subType}`);
};

export const createMaterialRequest = (id) =>
  post(`${CREATE_MATERIAL_REQUEST}/${id}`);

export const fetchProducts = () => get(PRODUCTS);

export const fetchInventoryAvailability = (productId) =>
  get(`api/v1/organisation/inventory/availability/${productId}`);

export const fetchVendorCategories = () => get(VENDOR_CATEGORIES);

export const fetchProductMasterTransactionData = (
  transactionCode,
  productDataId,
) =>
  get(
    `${PACKING_LIST}?tran_code=${transactionCode}&product_id=${productDataId}`,
  );

export const fetchProductMasterTransactionByWoNo = (transactionCode, woNo) =>
  get(
    `${PACKING_LIST}?tran_code=${transactionCode}&design_workorder=${encodeURIComponent(woNo)}`,
  );

export const fetchWbomByWoTranId = (woTranId) =>
  get(`${PACKING_LIST}?tran_code=WBOM&wo_tran_id=${woTranId}`);

export const updateTransactionSettings = (settingsData) =>
  post(UPDATE_TRANSACTION_SETTINGS, settingsData);

export const updateWbomTranIdInWO = (data) => post(INSERT_WBOM, data);

export const fetchBomByProduct = (productId) =>
  get(`${BOM_BY_PRODUCT}${productId}`, { noCache: true });

export const reviseQuotation = (tranId, submissionData) =>
  post(`${QUOTATION_REVISE}${tranId}`, submissionData);

export const fetchQuotationVersions = (tranId) =>
  get(`${QUOTATION_VERSIONS}${tranId}`, { noCache: true });

export const fetchLastHeadData = (tranCode, fields) =>
  get(`${LAST_HEAD_DATA}${tranCode}?fields=${fields.join(",")}`);

export const createCategory = (data) =>
  post(`${VENDOR_CATEGORY_LIST}/create`, data);

export const updateCategory = (categoryId, data) =>
  post(`${VENDOR_CATEGORY_LIST}/update/${categoryId}`, data);

export const deleteCategory = (categoryId) =>
  post(`${VENDOR_CATEGORY_LIST}/delete/${categoryId}`);

export const createSubcategory = (data) => post(CREATE_SUBCATEGORY, data);

export const updateSubcategory = (subcategoryId, data) =>
  post(`${UPDATE_SUBCATEGORY}${subcategoryId}`, data);

export const deleteSubcategory = (subcategoryId) =>
  post(`${DELETE_SUBCATEGORY}${subcategoryId}`);
